import { useState } from "react";
import { createPortal } from "react-dom";
import { Trash2, ShieldAlert } from "lucide-react";

export const DeleteEventDialog = ({ event, onClose, onConfirm }) => {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onConfirm(password);
    setBusy(false);
    if (ok) onClose();
    else setPassword("");
  };

  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/80 overflow-y-auto p-4" onClick={onClose}>
      <form
        onSubmit={submit}
        onClick={(e) => e.stopPropagation()}
        className="card p-7 max-w-lg w-full mx-auto my-16 border-red-500/30"
        data-testid="delete-event-modal"
      >
        <p className="flex items-center gap-2 text-red-400 text-xs uppercase tracking-widest font-mono2">
          <ShieldAlert size={14} /> Permanent deletion
        </p>
        <h3 className="font-display text-xl font-black mt-3" data-testid="delete-event-name">
          {event.name}
        </h3>
        <p className="text-sm text-slate-400 mt-3" data-testid="delete-event-warning">
          {event.registered > 0
            ? `This removes ${event.registered} registration(s), their passes and check-in records. Consider closing the event instead.`
            : "This cannot be undone."}
        </p>

        <label className="label mt-6 block">Delete password</label>
        <input
          type="password"
          className="input"
          autoFocus
          autoComplete="off"
          placeholder="Ask the event owner for this"
          data-testid="delete-event-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <p className="text-[11px] text-slate-500 mt-1.5">
          The event is only deleted if this password is correct.
        </p>

        <div className="flex flex-wrap gap-3 mt-6">
          <button
            className="btn-primary bg-red-500 hover:bg-red-400 text-white"
            disabled={busy || !password}
            data-testid="delete-event-confirm-btn"
          >
            <Trash2 size={15} /> {busy ? "Deleting…" : "Delete event"}
          </button>
          <button type="button" onClick={onClose} className="btn-secondary"
            data-testid="delete-event-cancel-btn">
            Cancel
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
};
